import React from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import "../../assets/css/sign-in.css";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const Forgot_Password = () => {
	return (
		<>
			{/* Header starts here */}
			<AuthHeader />
			{/* Header ends here */}
			{/* sign in starts here */}
			<section className="sign-in">
				<div className="container">
					<div className="row ">
						<div className="col-lg-4">
							<div className="sign-in-form-wrapper">
								<div className="heading-wrapper">
									<h2>Forgot Password</h2>
									<p>
										Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed
										diam nonumy aliquyam erat
									</p>
								</div>
								<div className="sign-form-wrapper">
									<form action="/OTP">
										<div className="form-group">
											<label htmlFor="">Enter Valid Email Address</label>
											<input
												className="form-control"
												type="email"
												placeholder="Enter The Email"
											/>
										</div>
										<div className="form-group">
											<button className="btn" type="submit">
												Code Send
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
						<div className="col-lg-1"></div>
						<div className="col-lg-7 align-self-center"></div>
					</div>
				</div>
			</section>
			{/* sign in ends here */}
			{/* Footer starts here */}
			<Footer />
			{/* Footer ends here */}
		</>
	);
};

export default Forgot_Password;
